import styled from '@emotion/styled';

import { breakpoints } from 'styles/basic';
import { css } from '@emotion/react';

interface SpecialDesignProps {
  isSpecialDesign?: boolean;
}

const Wrapper = styled.div<SpecialDesignProps>`
  padding: 1rem 0;
  background: ${(props) => props.theme.color.gray};
  font-size: 1.2rem;
  color: ${(props) => props.theme.color.darkGray};

  @media (min-width: ${breakpoints.portraitTablet}) {
    font-size: 1.2rem;
  }

  ${(props) => props.isSpecialDesign && css`
    background: #eac751;
    color: #2d2d2d;
  `}
`;

const BreadcrumbsList = styled.ul`
  display: flex;
  align-items: center;
  gap: .5rem;
  margin: 0;
  list-style: none;
`;

const BreadcrumbsItem = styled.li`
  display: -webkit-box;
  flex-shrink: 0;
  overflow: hidden;
  max-width: 17rem;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-transform: uppercase;

  &:not(:last-child)::after {
    content: '/';
    margin-left: .5rem;
  }
  &:last-of-type {
    flex-shrink: 1;
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    max-width: 25rem;
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    max-width: unset;
  }
`;

export {
  Wrapper,
  BreadcrumbsList,
  BreadcrumbsItem
};
